import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import InsumoTable from './components/InsumoTable';
import InsumoToolbar from './components/InsumoToolbar/InsumoToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';
import { Grid } from '@material-ui/core';
import {TextField}  from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function InsumoList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [insumos, setInsumos] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteInsumo, setShowDialogConfirmacaoDeleteInsumo] = useState(false);
  const [showDialogAtualizarEstoque, setShowDialogAtualizarEstoque] = useState(false);
  const [selectedIndexInsumo, setSelectedIndexInsumo] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openInsumoChangePassword, setOpenInsumoChangePassword] = useState(false);
  const [quantidadeInsumo, setQuantidadeInsumo] = useState(0);
  const [radioGroupValue, setRadioGroupValue] = React.useState('entrada');
  const [resfreshState, setRefreshState] = useState(new Date());


  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    carregarInsumos();
  }, []);

  async function carregarInsumos() {
    try{
      setLoading(true);
      const params = {
        limit: 100,
      };
      const dados = await api.get('insumos/', {params: params});
      console.log(dados.data);
      setLoading(false);
      if(dados.data.isSuccess){
        if(dados.data.result.length !== 0){
          for(let i = 0, size = dados.data.result.length; i < size; i++){
            dados.data.result[i].on_mouse_over = false;
          }
          setInsumos(dados.data);
        }
        else{
          setLoading(false);
          setTypeSnack('warning');
          setMessageSnack('Não há insumos cadastradas');
          setShowMessageSnack(true);
        }
      }
      else{
        setSucess(false);
      }

    }
    catch (e) {
      setSucess(false);

    }
  }

  const handleChange = (event) => {
    setRadioGroupValue(event.target.value);
  };

  function showConfirmationDeleteInsumo(index){
    if (selectedIndexInsumo < 0 && selectedIndexInsumo >= insumos.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexInsumo(index);
      setShowDialogConfirmacaoDeleteInsumo(true);
    }
  }

  function dialogAtualizarEstoque(index){
    setSelectedIndexInsumo(index);
    setShowDialogAtualizarEstoque(true);
  }

  async function atualizarEstoqueInsumo(){
    if (selectedIndexInsumo < 0 && selectedIndexInsumo >= insumos.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi fazer movimentação de estoque para esse insumo.');
      setShowMessageSnack(true);
    }
    else{
      try{
        const auth = JSON.parse(localStorage.getItem('auth'));
        setLoading(true);
        setShowDialogAtualizarEstoque(false);
        let novaQuantidadeInsumo = quantidadeInsumo;
        let tipoMovimentacao = '';
        if(radioGroupValue === 'entrada'){
          tipoMovimentacao = 'P';
          if(quantidadeInsumo < 0){
            novaQuantidadeInsumo = parseInt(quantidadeInsumo*-1);
          }
        }
        else{
          tipoMovimentacao = 'N';
          if(quantidadeInsumo > 0){
            novaQuantidadeInsumo = parseInt(quantidadeInsumo*-1);
          }
        }
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        const insumo_put = {
          quantidade: novaQuantidadeInsumo,
          tipoMovimentacao: tipoMovimentacao,
          idUsuario: auth.result.idUsuario
        };
        const dados = await api.put('insumos/estoque/'+insumos.result[selectedIndexInsumo].estoqueInsumo.idEstoqueInsumo, insumo_put);
        if(dados.data.isSuccess){
          setMessageSnack(dados.data.message);
          setTypeSnack('success');
          setShowMessageSnack(true);
          setShowDialogAtualizarEstoque(false);
          setRefreshState();
          carregarInsumos();
          setQuantidadeInsumo(0);
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          setShowDialogAtualizarEstoque(false);
        }
        setLoading(false);
      }
      catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
        setShowMessageSnack(true);
      }
    }
  }

  async function deleteInsumo() {
    if (selectedIndexInsumo < 0 && selectedIndexInsumo >= insumos.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o insumo');
      setShowMessageSnack(true);
    }
    else{
      try {
        setShowDialogConfirmacaoDeleteInsumo(false);
        setLoading(true);
        const id = insumos.result[selectedIndexInsumo].idInsumo;
        const dados = await api.delete(`insumos/${id}`);
        setCnpjConfirmation('');
        if (dados.data.isSuccess === true) {
          const params = {
            limit: 100,
          };
          const dados = await api.get('insumos/', { params: params });
          setLoading(false);
          if (dados.data.isSuccess === true) {
            setTypeSnack('success');
            setMessageSnack('Insumo deletado com sucesso');
            setShowMessageSnack(true);
            for (let i = 0, size = dados.data.result.length; i < size; i++) {
              dados.data.result[i].on_mouse_over = false;
            }
            setInsumos(dados.data);
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao carregar insumos');
            setShowMessageSnack(true);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar insumo. Contate o suporte.');
          setShowMessageSnack(true);
        }

      } catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
        setShowMessageSnack(true);
      }

    }
  }

  function onCancelDeleteInsumo() {
    setSelectedIndexInsumo(-1);
    setShowDialogConfirmacaoDeleteInsumo(false)
  }

  function onCancelAtualizarEstoque(){
    setSelectedIndexInsumo(-1);
    setQuantidadeInsumo(0);
    setShowDialogAtualizarEstoque(false);
  }

  async function filterInsumos(filterValue) {
    try {
      setLoading(true);
      const params = {
        descricao: filterValue
      };
      const dados = await api.get('insumos/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setInsumos(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openInsumoRegister() {
    const insumo = {
      descricao: '',
      quantidade: '',
      valorVenda: 0
    };
    history.push('/insumo-register/', {insumo: insumo, edicao: false});
  }

  async function openInsumoEdit(index) {
    try{
      if (index < 0 && index >= insumos.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar a insumo');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`insumos/${insumos.result[index].idInsumo}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/insumo-edit/', {insumo: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da insumo.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados da insumo.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setSucess(false);
    }
  }


  return (
    sucess
    ?
      <div
        className={classes.root}
      >
        <InsumoToolbar
          filterInsumos={filterInsumos}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />

        <Dialog open={showDialogConfirmacaoDeleteInsumo} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Remoção de insumo</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Você está tentando deletar o insumo com as seguintes informações:
            </Typography>
            <Typography
              gutterBottom
              style={{marginTop: '30px'}}
            >
              {selectedIndexInsumo < 0 || selectedIndexInsumo >= insumos.result.length ? '' :
                'Descricao: ' + insumos.result[selectedIndexInsumo].descricao
              }
            </Typography>
            <Typography gutterBottom>
              Tem certeza que deseja excluir esse insumo?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelDeleteInsumo} color="primary">
              Cancelar
            </Button>
            <Button onClick={deleteInsumo} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={showDialogAtualizarEstoque} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title"> {selectedIndexInsumo < 0 || selectedIndexInsumo >= insumos.result.length ? '' :
            'Atualização de Estoque - ' + insumos.result[selectedIndexInsumo].descricao}
          </DialogTitle>
          <DialogContent>
            <FormControl component="fieldset">
              <FormLabel component="legend">Tipo de Movimentação</FormLabel>
              <RadioGroup aria-label="gender" name="gender1" value={radioGroupValue} onChange={handleChange}>
                <Grid
                  container
                >
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <FormControlLabel value="entrada" control={<Radio color="primary"/>} label="Entrada" />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <FormControlLabel value="saida" control={<Radio color="primary"/>} label="Saída" />
                  </Grid>

                </Grid>
              </RadioGroup>
            </FormControl>
            <Typography
              gutterBottom
              style={{marginTop: '20px'}}
            >
              {selectedIndexInsumo < 0 || selectedIndexInsumo >= insumos.result.length ? '' :
                'Estoque atual: ' + insumos.result[selectedIndexInsumo].estoqueInsumo.quantidade
              }
            </Typography>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                type='number'
                fullWidth
                label="Quantidade"
                helperText="Insira o valor a ser decrementado/somado."
                margin="dense"
                name="quantidade"
                onChange={e => setQuantidadeInsumo(e.target.value)}
                value={quantidadeInsumo}
                variant="outlined"
              />
            </Grid>
            <Typography
              gutterBottom
              style={{marginTop: '20px'}}
            >
              {
                'Estoque atualizado: ' +
                (
                  (radioGroupValue === 'entrada' && selectedIndexInsumo >= 0 && selectedIndexInsumo < insumos.result.length &&
                    (parseInt(insumos.result[selectedIndexInsumo].estoqueInsumo.quantidade) + parseInt(quantidadeInsumo || 0))
                  )
                  ||
                  (radioGroupValue === 'saida' && selectedIndexInsumo >= 0 && selectedIndexInsumo < insumos.result.length &&
                    (parseInt(insumos.result[selectedIndexInsumo].estoqueInsumo.quantidade) - parseInt(quantidadeInsumo || 0))
                  )
                  ||
                  0
                )
              }

            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelAtualizarEstoque} color="primary">
              Cancelar
            </Button>
            <Button onClick={atualizarEstoqueInsumo} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>



        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          <InsumoTable
            insumos={insumos}
            setInsumos={setInsumos}
            deleteInsumo={showConfirmationDeleteInsumo}
            atualizarEstoque={dialogAtualizarEstoque}
            editInsumo={openInsumoEdit}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div
          className={classes.divFab}

        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openInsumoRegister}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
      :
      <NotFoundView/>

  );
};

export default InsumoList;
